import { ApiError, type AdminClient } from '../core/index.js'

const NOT_DEPLOYED = 'This API does not serve its reference to the admin area yet. Deploy the API to switch this on.'

/** The system module's admin calls: the API reference. */
export interface SystemAdminApi {
  /** The API reference, as the HTML page the API serves it as (`GET /admin/docs`). */
  readApiDocs(): Promise<string>
}

export function createSystemAdminApi(client: AdminClient): SystemAdminApi {
  return {
    // A page of HTML, not the JSON envelope `call` reads.
    readApiDocs: async () => {
      let response: Response
      try {
        response = await client.request('/admin/docs')
      } catch (error) {
        // An API from before this endpoint existed asks for a bearer token (401). That is not a wrong password, and saying
        // so would send the admin to sign in again for nothing; the client has already turned the 401 into an ApiError.
        if (error instanceof ApiError && error.status === 401) {
          throw new ApiError(NOT_DEPLOYED, 401)
        }
        throw error
      }
      if (response.status === 404) {
        throw new ApiError(NOT_DEPLOYED, 404)
      }
      if (!response.ok) {
        throw new ApiError(`The API reference could not be loaded (${response.status})`, response.status)
      }
      return response.text()
    },
  }
}
